var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VFlex',{class:`xs12 sm${_vm.width} mb-2 location-modal-data`},[_c('span',{staticClass:"font-weight-bold mr-2"},[_vm._v(_vm._s(_vm.title)+" :")]),_c('div',{class:_vm.display},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }